// Lightweight profanity filter using `bad-words` (~5kb).
// First-line client-side defense; never the only check.
import { Filter } from "bad-words";

let _filter: Filter | null = null;
const getFilter = () => {
  if (!_filter) {
    _filter = new Filter();
    // Add a few additional banned terms commonly missed
    _filter.addWords("nazi", "kkk");
  }
  return _filter;
};

export const containsProfanity = (text: string | null | undefined): boolean => {
  if (!text) return false;
  try {
    return getFilter().isProfane(text);
  } catch {
    return false;
  }
};

export const cleanProfanity = (text: string): string => {
  try {
    return getFilter().clean(text);
  } catch {
    return text;
  }
};

/**
 * Returns null if clean, otherwise an error message describing the issue.
 * Use as a single check before submitting any user-generated text.
 */
export const validateClean = (text: string | null | undefined, fieldLabel = "This field"): string | null => {
  if (!text) return null;
  if (containsProfanity(text)) {
    return `${fieldLabel} contains language that isn't allowed. Please revise.`;
  }
  return null;
};
